// extracted by mini-css-extract-plugin
export default {"referralProgramDetails":"ReferralProgramDetails_referralProgramDetails__hbfct"};